import { Reveal } from "@/components/common";
import { useFetch } from "@/lib/api";
import { Attribution, QuoteMark } from "./parts";

export const ProjectPullQuote = ({ projectId }) => {
  const { data } = useFetch(`/testimonials?project_id=${projectId}`);
  if (!data?.length) return null;
  return (
    <section className="container-x py-14 md:py-20" data-testid="case-testimonials" aria-label="Testimonial">
      {data.map((t) => (
        <Reveal key={t.id}>
          <figure className="relative mx-auto max-w-5xl border-y border-gold/30 py-14 md:py-20 md:pl-24" data-testid={`case-testimonial-${t.id}`}>
            <QuoteMark className="text-[7rem] md:absolute md:left-0 md:top-16 md:text-[9rem]" />
            <blockquote>
              <p className="font-display text-3xl leading-[1.15] md:text-5xl" data-testid={`case-testimonial-quote-${t.id}`}>{t.quote}</p>
            </blockquote>
            <div className="mt-10"><Attribution t={t} showProject={false} /></div>
          </figure>
        </Reveal>
      ))}
    </section>
  );
};
